import * as React from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { getLanguageFromLocale } from '../../Intl/utils';
import { getNotation } from '../util';

import getLogger, { Logger } from '../../log';

const logger: Logger = getLogger('Vocabulary/Notation');

interface Props {
  v: string; // vocabulary
  l?: string; // language
  p?: string; // partition
  k: string; // key
  r?: boolean; // required
  children?: (notation: string) => React.ReactNode; // optional render function
}

export const Notation = (props: Props): any => {
  const l: string = props.l ? props.l : null;
  const p: string = props.p ? props.p : '*';
  const r: boolean = props.r ? props.r : false;
  const children: (notation: string) => React.ReactNode = props.children ? props.children : null;
  const v: string = props.v;
  const k: string = props.k;
  const intl: IntlShape = useIntl();
  const lang: string = !!l ? l : getLanguageFromLocale(intl.locale);

  try {
    const notation: string = getNotation(v, k, lang, p);
    if (typeof children !== 'function') {
      return notation;
    }

    return children(notation);
  } catch (e) {
    if (r) {
      throw e;
    }
    logger.warn('Lookup failed', props);
    return <i>{k}</i>;
  }
};
